import { ElMenu, ElMenuItem, ElSubMenu } from 'element-plus'
import { useI18n } from 'i18n-utils'
import { ArrowDownLineIcon } from 'ui-components'
import { useResponsive } from 'store'
import classNames from 'classnames'
import useUserCommon from '@/hooks/use-user-common.ts'
import './AsideMenu.scss'

export const AsideMenu = defineComponent({
  name: 'AsideMenu',
  setup() {
    const { t } = useI18n()
    const route = useRoute()
    const responsive = useResponsive()
    const isMobileMenuOpen = ref(false)
    const { menuList } = useUserCommon()

    const onMenuClick = () => {
      isMobileMenuOpen.value = false
    }

    const MenuComp = () => (
      <ElMenu defaultOpeneds={['assets']} defaultActive={route.path} router>
        {menuList.value.map((menu) => {
          if (menu.children && menu.children.length > 0) {
            return (
              <ElSubMenu key={menu.title} index={menu.path!}>
                {{
                  title: () => (
                    <div class={'menu-title'}>
                      {menu.icon}
                      <span class={'menu-title-text'}>{t(menu.title)}</span>
                    </div>
                  ),
                  default: () =>
                    menu!.children!.map((child) => (
                      <ElMenuItem key={child.title} index={child.path} onClick={onMenuClick}>
                        <span class={'menu-title-text'}>{t(child.title)}</span>
                      </ElMenuItem>
                    )),
                }}
              </ElSubMenu>
            )
          }
          return (
            <ElMenuItem key={menu.title} index={menu.path} onClick={onMenuClick}>
              {{
                title: () => (
                  <div class={'menu-title'}>
                    {menu.icon}
                    <span class={'menu-title-text'}>{t(menu.title)}</span>
                  </div>
                ),
              }}
            </ElMenuItem>
          )
        })}
      </ElMenu>
    )
    watch(
      () => isMobileMenuOpen.value,
      (isOpen) => {
        if (isOpen) {
          document.documentElement.style.overflow = 'hidden'
        } else {
          document.documentElement.style.overflow = 'initial'
        }
      },
    )

    return () => {
      if (responsive.userCenterMobileParams.isMobile) {
        return (
          <div class="mobile-menu-layout user-mobile-menu" onClick={() => (isMobileMenuOpen.value = !isMobileMenuOpen.value)}>
            <ArrowDownLineIcon class={classNames('menu-icon', { 'is-open': isMobileMenuOpen.value })} />
            <div class={classNames('user-mobile-menu-container', { 'is-open': isMobileMenuOpen.value })} onClick={(e) => e.stopPropagation()}>
              <div class="aside-menu-layout">
                <div class="aside-menu-container">
                  <MenuComp />
                </div>
              </div>
            </div>
          </div>
        )
      }
      return (
        <div class="aside-menu-layout">
          <div class="aside-menu-container">
            <MenuComp />
          </div>
        </div>
      )
    }
  },
})
